import React from 'react';
import { useTranslation } from 'react-i18next';

const PageNavigationButton = ({ onClickHandler, i18nLabel, url, clickHandlerOptions }) => {
	const { t } = useTranslation('pageNavigation');

	return (
		<button
			className="page_navigation__link"
			type="button"
			onClick={e => onClickHandler(e, url, clickHandlerOptions)}
		>
			{t(i18nLabel)}
		</button>
	);
};

export default PageNavigationButton;
